export default __webpack_public_path__ + "c3967e902311541e4d538c970611aa13.ttf";